import React, {useEffect} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link >
      FS Lab Services
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height:'100%',
    width:"100%"
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignInSide() {
  const classes = useStyles();
  const [ID,setID]=React.useState('')
  const [password,setPassword]=React.useState('')
useEffect(()=>{
    if(localStorage.getItem('user_id')!=null && localStorage.getItem('user_id')!=undefined){
        window.location.href="https://feedsign.fslabs.com.pk"
      }
    // testAPI();
},[])

async function testAPI() {
//   const API_KEY = "metropol_7f3a9c2e1b4d5f8a0e6c3d2b9a1f4e7c";

// const payload = {
//   template: "biopsy_small",
//   transcription:
//     "Histology number S-26-682. Specimen type is cervical polyp.",
// };
//   try {
//     const response = await fetch(
//       "https://midl.comsats.edu.pk/metropol/extract",
//       {
//         method: "POST",
//         // headers: {
//         //   "Content-Type": "application/json",
//         //   "METROPOL_API_KEY": API_KEY,
//         // },
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${API_KEY}`,
//         },
//         body: JSON.stringify(payload),
//       }
//     );

//     console.log("Status Code:", response.status);

//     const result = await response.json();

//     console.log("Full Response:", result);

//     if (response.ok) {
//       console.log("API Working Successfully");
//     } else {
//       console.log("API Error:", result);
//     }
//   } catch (error) {
//     console.log("Fetch Error:", error);
//   }
const API_URL = "https://midl.comsats.edu.pk/metropol";
const API_KEY = "metropol_7f3a9c2e1b4d5f8a0e6c3d2b9a1f4e7c";

const headers = {
  "Content-Type": "application/json",
  "x-api-key": API_KEY, // same as your Streamlit code
};
// try {
//   const res = await fetch(`${API_URL}/health`, {
//     method: "GET",
//     headers,
//   });

//   const data = await res.json();
//   console.log(data)
//   return data;
// } catch (error) {
//   console.error("Health Error:", error);
//   throw error;
// }
// 2nd
try {
  const res = await fetch(`${API_URL}/templates`, {
    method: "GET",
    headers,
  });

  const data = await res.json();
    console.log(data)
  return data;
} catch (error) {
  console.error("Templates Error:", error);
  throw error;
}

}

  const handleDeleteChat = async () => {
    const instanceId = 'instance95224';  // Replace with your instance ID
    const token = '2vxh4vp43ft76vvm';             // Replace with your token
    const chatId = '971507032874@c.us';     // Replace with the chat ID you want to delete

    const url = `https://api.ultramsg.com/${instanceId}/chats/delete`;

    const formData = new URLSearchParams();
    formData.append('token', token);
    formData.append('chatId', chatId);

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      const result = await response.json();
      console.log(result);  // Handle the response
    } catch (error) {
      console.error('Error:', error);  // Handle the error
    }
  };
  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7}  >
      <img src={require("../fontDesk_FS.jpg")} className={classes.image} />  
 
      </Grid>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
        <img src={require('../logo.png')} width="30%"/>

          <Typography component="h1" variant="h5">
            Welcome Branch Managers
          </Typography>
          <Typography  variant="h5" style={{fontSize:20}}>
           Result Feeding & Signing
          </Typography>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="id"
              label="Username"
              name="ID"
              value={ID}
              onChange={(e)=>{
                setID(e.target.value)
              }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e)=>{
                setPassword(e.target.value)
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={()=>{
                // var url ="http://192.168.0.107:2100/whatsapp"
  
                // fetch(url).then((res)=>res.json())
                //  .then((result)=>{
              
                
                // })
                // handleDeleteChat()
                if(ID.trim()==''){
                  alert("Invalid Username")
                  return
                }
                if(password.trim()==''){
                  alert("Invalid Password")
                }
                   var log='ID'
                  fetch('https://eviewer.fslabs.com.pk/4DACTION/WebLogin',{
                    method: 'POST',
                    'Content-Type':"application/json",
                    body:'vUID=' + ID + '&vPW=' + password + '&vRole=Admin&vLoginType=' + log + "&vRandom=" + 21211
                  }).then((res)=>res.text()).then( async(resss)=>{
                    console.log(resss)
                    var res=JSON.parse(resss)
                    if(res.Result){
                      localStorage.clear()
                      localStorage.setItem('user_id',res.User_ID)
                      localStorage.setItem('name',res.Name)
                      localStorage.setItem('branch_id',res.Branch_ID);
                      if(res.Branch_ID!="0"){
                        localStorage.setItem('branch_name',res.Name);
                      }

                      localStorage.setItem("panel_code",res.panel_code)
                      localStorage.setItem("panel_name",res.panel_name)
                      var vSearchStr = {
                        "User_ID": localStorage.getItem('user_id'),
                        "Menu_Option": "Franchise Share Summary"
                      }
                      fetch("https://eviewer.fslabs.com.pk/4DACTION/WebCheckUserStatusActiveAccess", {
                        method: "POST",
                        'Content-Type': "application/json",
                        body: JSON.stringify(vSearchStr)
                      }).then(res => res.json()).then((res) => {
                        console.log(res)
                        if (res[0].Option_Status == "Authorized") {
                          
                          localStorage.setItem("franchise","true")

                        }
                      })
                      var vSearchStr = {
                        "User_ID": localStorage.getItem('user_id'),
                        // "Menu_Option": "Allowed to Sign the Reports"
                        "Menu_Option": "Test Results Finalize"
                      }
                      fetch("https://eviewer.fslabs.com.pk/4DACTION/WebCheckUserStatusActiveAccess", {
                        method: "POST",
                        'Content-Type': "application/json",
                        body: JSON.stringify(vSearchStr)
                      }).then(res => res.json()).then((res) => {
                        if (res[0].Option_Status == "Authorized") {
                          
                          localStorage.setItem("signing","true")

                        }
                      })
                      var vSearchStr = {
                        "User_ID": localStorage.getItem('user_id'),
                        "Menu_Option": "Invoice Balance Receiving"
                      }
                      fetch("https://eviewer.fslabs.com.pk/4DACTION/WebCheckUserStatusActiveAccess", {
                        method: "POST",
                        'Content-Type': "application/json",
                        body: JSON.stringify(vSearchStr)
                      }).then(res => res.json()).then((res) => {
                        if (res[0].Option_Status == "Authorized") {
                          
                          localStorage.setItem("balance","true")

                        }
                        setTimeout(()=>{
                          window.location.href="https://feedsign.fslabs.com.pk"
                        },1500)
                      })
                      localStorage.setItem('org_branch_id',res.Branch_ID);
                      localStorage.setItem("patient_mobile","")
                      localStorage.setItem("patient_name","")                      
                      alert('Login Successfully!!')             
                    }
                    else{
                      alert('Invalid Credentials !')
                      return
                    }
                  }) 
              }}
            >
              Login
            </Button>
        
            <Box mt={5}>
              <Copyright />
            </Box>
          </div>
      </Grid>
    </Grid>
  );
}